import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grievance-details',
  templateUrl: './grievance-details.component.html',
  styleUrls: ['./grievance-details.component.scss']
})
export class GrievanceDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
